<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 10:52:20
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-18 15:57:47
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\step01 copy 4.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='step-box'>
        <div class="step-content">
            <div class="step-title">上传其他信息 <span class="red">*</span></div>

            <div class="other-item-list">
                <OtherItem title="门头照片" desc="请于门外拍摄完整的门口照片，要求招牌名字和商户名一致" @upload="uploadImg" :img="params.shopGatePic"
                    type="shopGatePic" />
                <OtherItem title="收银台照片" desc="请拍摄门店内的收银台，请勿拍摄单一物品" @upload="uploadImg" :img="params.cashierDeskPic"
                    type="cashierDeskPic" />
                <OtherItem title="店内环境照片" desc="请拍摄门店内的服务设施和场所环境，请勿拍摄单一物品" @upload="uploadImg" :img="params.shopPic"
                    type="shopPic" />

            </div>
        </div>

        <Footer @giveup="giveup" @confirm="confirm" :step="3"  @back="goProstep" />
    </div>
</template>

<script>
import { Toast } from 'vant';

import OtherItem from './otherItem.vue';
import Footer from "./footer.vue"
import { merchTriplePhoto } from "@/api/index"
export default {
    name: 'Step04',
    components: {
        OtherItem,
        Footer
    },
    props: {
        merchartInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    watch: {
        merchartInfo: {
            immediate: false,
            deep: true,
            handler(val) {
                this.params.keys.forEach(key => {
                    this.params[key] = val[key]
                });
            }
        }
    },
    data() {
        return {
            params: {
                shopGatePic: '', // 门头照片
                cashierDeskPic: "", // 收银台照片
                shopPic: "", // 店内照片
                registerId: "", // 进件 ID
            }
        };
    },
    created() {
        Object.keys(this.params).forEach(key => {
            this.params[key] = this.merchartInfo[key]
        });
        this.params.registerId = this.merchartInfo.id
    },
    methods: {
        uploadImg(file) {
            this.params[file.type] = file.url
            Toast.clear()
        },

        // 上一步
        goProstep() {
            this.$emit("goProstep", { step: 3 })
        },

        // 下一步
        confirm() {
            // 判断照片是否已上传

            if (!this.params.shopGatePic) {
                Toast("请上传门头照片！")
                return;
            }

            if (!this.params.cashierDeskPic) {
                Toast("请上传收银台照片！")
                return;
            }

            if (!this.params.shopPic) {
                Toast("请上传店内照片！")
                return;
            }

            // 校验表单是否有为空的内容
            if (!this.objIsNull(this.params)) {
                Toast("请完整填写表单！")
                return;
            }
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: "toast"
            });
            merchTriplePhoto(this.params).then(res => {
                if (res.code != 200) {
                    Toast(res.msg)
                    return;
                }
                this.$emit("confirm", { data: res.data, step: 3 })
            })
        },

        // 放弃注册
        giveup() {
            this.$emit("giveup")
        }
    },
};
</script>

<style scoped lang="scss">
.step-box {
    height: 100%;
    background-color: #fff;
}
</style>